import { createContext, useContext } from 'react';
import type { UseSymbolGroupsResult } from 'hooks/canvas/useSymbolGroups';

/**
 * Context that distributes the symbol-group state and mutation helpers
 * to all consumers (per-component badges, popover, manage dialog, the
 * workspace toolbar button) without prop drilling through 15 different
 * Canvas* component types.
 *
 * Provided at the layout root in Canvas.tsx, fed by `useSymbolGroups()`.
 */
export const CanvasGroupContext = createContext<UseSymbolGroupsResult | null>(
  null,
);

export const useCanvasGroupCtx = (): UseSymbolGroupsResult => {
  const ctx = useContext(CanvasGroupContext);
  if (ctx == null) {
    throw new Error(
      'useCanvasGroupCtx must be used within a <CanvasGroupContext.Provider>',
    );
  }
  return ctx;
};
